
import * as types from '../mutation-types';

const login = {
    namespaced: true,
    state: {
        login: false
    },
    mutations: {
        [types.APP_LOGIN](state) {
            
        }
    },
    actions: {
        
    },
    getters: {
        getLogin: state => state.login
    }
}

export default login;